module.exports = __webpack_public_path__ + "assets/img/gpt1-1.461954e1.png";